import { skipToken, useQuery } from '@tanstack/react-query'
import { featureFlagsQueryKey } from 'v2/shared/utils/query-key-management'
import { useAuth } from './use-auth'

/**
 * Whether the feature-flag fetch failed outright — as opposed to "still loading".
 *
 * `skipToken` subscribes WITHOUT ever fetching, so this observes the entry the real
 * hook owns and never issues a second request. The flags query sets `retry: false`,
 * so its error state is terminal and reached on the first failure.
 *
 * Deliberately NOT folded into the flags object as `isInitialData`: that means
 * "flags not fetched yet" (unknown), and use-livekit-enabled surfaces it as its own
 * isLoading so use-publish-flow can omit `livekit_ready` while unknown rather than
 * publish `false`. Rewriting it there would assert "LiveKit is off" for every org on
 * a transient flag outage.
 */
export const useFeatureFlagsFetchFailed = () => {
  const { details } = useAuth()
  const { isError } = useQuery({
    queryKey: featureFlagsQueryKey(details?.email, details?.organization_name),
    queryFn: skipToken,
  })
  return isError
}
